export { SpaMetadata } from './SpaMetadata';
